import React, { Component } from "react";
import {ShrinkNumber} from '../util/Helper'
class BenchmarkRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valuePoint:-1,
    };
  }

  componentDidMount(){
    this.setValues();
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.refreshTimeStamp && this.props.refreshTimeStamp && prevProps.refreshTimeStamp !== this.props.refreshTimeStamp){
      this.setValues();
    } 
  }

  setValues = () =>{
    console.log('setValues')
    var _prev = {};
    var _curr = {};
    var _next = {};

    var _min = 0;
    var _max = 0;

    this.props.row.points.sort((a,b) => a.value - b.value);

    for (let i = 0; i < this.props.row.points.length; i++) {
      _curr = this.props.row.points[i];
      _prev = this.props.row.points[i-1];
      _next = this.props.row.points[i+1];


      _min = _prev ? _curr.value - ((_curr.value-_prev.value) / 2)  : 0;
      _max = _next ? _curr.value + ((_next.value-_curr.value) / 2) : 9999999999;

      
      if(this.props.row.value && this.props.row.value >= _min && this.props.row.value < _max){
        console.log(_min);
        console.log(this.props.row.value);
        console.log(_max);
        var pointLocation = 'vpRightCenter';
        if(this.props.row.value === _curr.value*1) pointLocation = 'vpCenter';
        else if(this.props.row.value === _min) pointLocation = 'vpLeft';
        else if(this.props.row.value === _max) pointLocation = 'vpRight';
        else if(this.props.row.value < _curr.value*1) pointLocation = 'vpLeftCenter';

        this.setState({valuePoint:i, pointLocation})
      }
      
    }
  }

  render() {
    return (
      <div className="benchmarkRow">
        <div className="bmrTitleContainer">
          <span className="bmrTitle">{this.props.row.title}</span>
          {this.props.row.note && 
          <span  className="bmrNote">({this.props.row.note})</span>
          }
        </div>
        {this.props.row.points.map((point, index) => {
          return <div className="bmrPointContainer">
                 <span className="bmrpTitle">{point.title}</span>
                 <div className="bmrpBar">
                  <div className="center"></div>
                  {this.state.valuePoint == index &&
                   <div className={"valuePoint " + this.state.pointLocation} >
                    <span>${ShrinkNumber(this.props.row.value)}</span>
                   </div>
                  }
                 </div>
                 <span className="bmrpValue">${ShrinkNumber(point.value)}</span>
                </div>
        })}
      </div>
    );
  }
}
 
export default BenchmarkRow;